module.exports = __webpack_public_path__ + "img/computer.a14faeed.png";